export const neuronMedia = {
  logo: "https://images.unsplash.com/photo-1529333166437-7750a6dd5a70?auto=format&fit=crop&w=400&h=400&q=80",
  banners: {
    main: "/assets/images/neuron-cons/1.jpg",
    operations: "/assets/images/neuron-cons/event-security.jpg",
    training: "/assets/images/neuron-cons/HEAT-trainings.jpeg",
    escort: "https://images.pexels.com/photos/15482700/pexels-photo-15482700.jpeg?auto=compress&cs=tinysrgb&w=1800"
  },
  gallery: [
    "https://images.pexels.com/photos/15482700/pexels-photo-15482700.jpeg?auto=compress&cs=tinysrgb&w=900",
    "https://images.pexels.com/photos/30481728/pexels-photo-30481728.jpeg?auto=compress&cs=tinysrgb&w=900",
    "https://images.pexels.com/photos/11022578/pexels-photo-11022578.jpeg?auto=compress&cs=tinysrgb&w=900",
    "https://images.pexels.com/photos/34104796/pexels-photo-34104796.jpeg?auto=compress&cs=tinysrgb&w=900",
    "https://images.unsplash.com/photo-1584143257259-50212e2ab820?auto=format&fit=crop&w=900&h=700&q=80",
    "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?auto=format&fit=crop&w=900&h=700&q=80"
  ]
};

export const heroSlides = [
  {
    smallTitle: "Protective Security Operations",
    title: "Discreet executive protection and mission-ready risk control across East Africa.",
    info: "Neuron Consultancy Kenya Ltd supports corporate, private and project clients with controlled deployment, disciplined reporting and 24/7 readiness.",
    cta: { label: "Explore Services", link: "/services" },
    bg: neuronMedia.banners.main,
    sideImage: "/assets/images/neuron-cons/1.jpg"
  },
  {
    smallTitle: "Secure Mobility & Field Support",
    title: "Threat-aware movement planning for executives, teams and field operations.",
    info: "From route planning to secure transfer and backup escalation, we keep operations moving safely in dynamic environments.",
    cta: { label: "View Mission", link: "/mission" },
    bg: neuronMedia.banners.operations,
    sideImage: "https://images.pexels.com/photos/11022578/pexels-photo-11022578.jpeg?auto=compress&cs=tinysrgb&w=700"
  },
  {
    smallTitle: "Training & Preparedness",
    title: "HEAT and MRE readiness programs tailored for field realities.",
    info: "We deliver scenario-based training that improves judgement, communication and team response under pressure.",
    cta: { label: "Talk to Our Team", link: "/contact-us" },
    bg: neuronMedia.banners.training,
    sideImage: "/assets/images/neuron-cons/HEAT-trainings.jpeg"
  }
];

export const services = [
  {
    slug: "executive-vip-protection",
    icon: "flaticon-security",
    title: "Executive & VIP Protection",
    category: "Close Protection",
    summary: "Discreet protection for executives, delegations and high-profile visitors.",
    detail: "Advance planning, venue screening, movement control and low-visibility protective coverage.",
    image: "https://images.pexels.com/photos/15482700/pexels-photo-15482700.jpeg?auto=compress&cs=tinysrgb&w=1200"
  },
  {
    slug: "protective-surveillance",
    icon: "flaticon-data",
    title: "Protective Surveillance",
    category: "Threat Monitoring",
    summary: "Field and urban surveillance to identify risk indicators early.",
    detail: "Structured intelligence collection, reporting chains and dynamic risk updates.",
    image: "https://images.pexels.com/photos/30481728/pexels-photo-30481728.jpeg?auto=compress&cs=tinysrgb&w=1200"
  },
  {
    slug: "secure-mobility",
    icon: "flaticon-map-location",
    title: "Secure Mobility",
    category: "Travel Security",
    summary: "Secure transfers, route checks and convoy coordination for safe movement.",
    detail: "Pre-movement assessment, timing control, fallback routing and real-time liaison.",
    image: "https://images.pexels.com/photos/11022578/pexels-photo-11022578.jpeg?auto=compress&cs=tinysrgb&w=1200"
  },
  {
    slug: "project-asset-security",
    icon: "flaticon-programmer",
    title: "Project & Asset Security",
    category: "Site Protection",
    summary: "Layered site protection for infrastructure, facilities and high-value assets.",
    detail: "Access control, guard supervision, perimeter discipline and escalation coverage.",
    image: "https://images.unsplash.com/photo-1584143257259-50212e2ab820?auto=format&fit=crop&w=1200&h=800&q=80"
  },
  {
    slug: "security-advisory",
    icon: "flaticon-download",
    title: "Security Advisory",
    category: "Risk Consulting",
    summary: "Security planning, audits and advisory support for operational leadership.",
    detail: "Threat mapping, control recommendations and implementation-ready procedures.",
    image: "https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?auto=format&fit=crop&w=1200&h=800&q=80"
  },
  {
    slug: "heat-mre-training",
    icon: "flaticon-smart-contracts",
    title: "HEAT & MRE Training",
    category: "Preparedness",
    summary: "Scenario-based training for teams operating in demanding environments.",
    detail: "Practical drills, emergency protocols and field decision-making readiness.",
    image: "/assets/images/neuron-cons/HEAT-trainings.jpeg"
  }
];

export const serviceDetailContent = {
  watermark: "Operational Security",
  title: "Integrated security delivery built around your risk environment.",
  intro: [
    "Neuron Consultancy Kenya Ltd combines protective operations, surveillance, secure mobility, stakeholder liaison and readiness training into one coordinated delivery model.",
    "We scope each assignment through threat, exposure and operational continuity lenses so clients receive a practical service plan instead of a generic checklist."
  ],
  pillars: [
    { icon: "flaticon-security", title: "Protective Operations", subtitle: "Executive, project and asset security" },
    { icon: "flaticon-map-location", title: "Mobility Security", subtitle: "Secure routes, transfers and movement planning" },
    { icon: "flaticon-smart-contracts", title: "Readiness Programs", subtitle: "HEAT and MRE capability development" }
  ],
  closing:
    "Our operations teams maintain clear communication channels, documented escalation procedures and accountable reporting so clients can make informed decisions quickly during live operations."
};

export const caseStudies = [
  {
    slug: "energy-project-security",
    category: "Energy Project Security",
    title: "Layered protection model for a remote drilling support site",
    image: "/assets/images/neuron-cons/5.jpg",
    summary: "Physical security and controlled access strategy for an active remote project zone.",
    details: "The operation combined gate control, patrol rotations, contractor coordination and contingency response protocols to reduce disruption and unauthorized access.",
    date: "18 Apr 2026",
    author: "Neuron Operations Team",
    serviceType: "Project Security",
    highlights: [
      "Layered entry and verification process",
      "24/7 patrol and incident escalation",
      "Daily coordination with project supervisors"
    ],
    relatedImages: [
      "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?auto=format&fit=crop&w=1200&h=800&q=80",
      "https://images.unsplash.com/photo-1542314831-068cd1dbfeeb?auto=format&fit=crop&w=1200&h=800&q=80"
    ]
  },
  {
    slug: "executive-movement-security",
    category: "Executive Movement",
    title: "Low-visibility principal protection for multi-city executive travel",
    image: "/assets/images/neuron-cons/event-security.jpg",
    summary: "Secure movement planning and principal protection for tight executive schedules.",
    details: "Advance checks, route alternatives and standby support teams protected movement windows while reducing interruption to business programs.",
    date: "12 Apr 2026",
    author: "Neuron Mobility Unit",
    serviceType: "Executive Security",
    highlights: [
      "Route risk checks and timing control",
      "Discreet close protection coverage",
      "Communication protocol for rapid adjustment"
    ],
    relatedImages: [
      "https://images.unsplash.com/photo-1500530855697-b586d89ba3ee?auto=format&fit=crop&w=1200&h=800&q=80",
      "https://images.unsplash.com/photo-1477959858617-67f85cf4f1df?auto=format&fit=crop&w=1200&h=800&q=80"
    ]
  },
  {
    slug: "ngo-field-support",
    category: "NGO Field Support",
    title: "Threat-aware protective support for humanitarian field teams",
    image: "/assets/images/neuron-cons/6.jpg",
    summary: "Movement and liaison support for humanitarian teams in exposed zones.",
    details: "Local awareness, field monitoring and secure logistics improved delivery continuity and reduced exposure during program activity.",
    date: "06 Apr 2026",
    author: "Neuron Field Services",
    serviceType: "Protective Surveillance",
    highlights: [
      "Community-aware movement planning",
      "Live field updates for team leaders",
      "Escalation playbooks for changing risk"
    ],
    relatedImages: [
      "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=1200&h=800&q=80",
      "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1200&h=800&q=80"
    ]
  },
  {
    slug: "stakeholder-engagement-security",
    category: "Stakeholder Liaison",
    title: "Community-facing security coordination for project stability",
    image: "https://images.unsplash.com/photo-1531058020387-3be344556be6?auto=format&fit=crop&w=1200&h=800&q=80",
    summary: "Structured local engagement that supports safe and stable project operations.",
    details: "Our liaison model aligned field security procedures with local administration and community concerns to reduce friction and improve acceptance.",
    date: "30 Mar 2026",
    author: "Neuron Liaison Group",
    serviceType: "Community Security",
    highlights: [
      "Regular stakeholder briefings",
      "Incident communication pathways",
      "Localized access and movement protocols"
    ],
    relatedImages: [
      "https://images.unsplash.com/photo-1527443154391-507e9dc6c5cc?auto=format&fit=crop&w=1200&h=800&q=80",
      "https://images.unsplash.com/photo-1496307042754-b4aa456c4a2d?auto=format&fit=crop&w=1200&h=800&q=80"
    ]
  },
  {
    slug: "asset-protection-operations",
    category: "Asset Protection",
    title: "Security posture upgrade for high-value private and corporate assets",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=1200&h=800&q=80",
    summary: "Protective controls and guard oversight for high-value environments.",
    details: "The assignment covered vulnerability review, access hardening, deployment standards and escalation thresholds to strengthen continuity and deterrence.",
    date: "22 Mar 2026",
    author: "Neuron Asset Defense",
    serviceType: "Asset Security",
    highlights: [
      "Access hardening and review",
      "Guard supervision standards",
      "Incident escalation and reporting model"
    ],
    relatedImages: [
      "https://images.unsplash.com/photo-1519389950473-47ba0277781c?auto=format&fit=crop&w=1200&h=800&q=80",
      "https://images.unsplash.com/photo-1490111718993-d98654ce6cf7?auto=format&fit=crop&w=1200&h=800&q=80"
    ]
  },
  {
    slug: "training-deployment-program",
    category: "Training Deployment",
    title: "HEAT and MRE readiness program for mixed field teams",
    image: "/assets/images/neuron-cons/HEAT-trainings.jpeg",
    summary: "Practical readiness training aligned with actual field stressors.",
    details: "Scenario-led sessions improved incident awareness, communication discipline and emergency reaction speed for field personnel.",
    date: "15 Mar 2026",
    author: "Neuron Training Division",
    serviceType: "Readiness Training",
    highlights: [
      "Scenario-led HEAT and MRE modules",
      "Sector-specific team adaptation",
      "Post-training performance review"
    ],
    relatedImages: [
      "https://images.unsplash.com/photo-1516321318423-f06f85e504b3?auto=format&fit=crop&w=1200&h=800&q=80",
      "https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1200&h=800&q=80"
    ]
  }
];

export const teamUnits = [
  { name: "Close Protection Detail", role: "Executive Security", image: "https://images.pexels.com/photos/15482700/pexels-photo-15482700.jpeg?auto=compress&cs=tinysrgb&w=700&h=900&dpr=1" },
  { name: "Intelligence Cell", role: "Threat Monitoring", image: "https://images.pexels.com/photos/30481728/pexels-photo-30481728.jpeg?auto=compress&cs=tinysrgb&w=700&h=900&dpr=1" },
  { name: "Mobility Operations", role: "Secure Travel", image: "https://images.pexels.com/photos/11022578/pexels-photo-11022578.jpeg?auto=compress&cs=tinysrgb&w=700&h=900&dpr=1" },
  { name: "Training & Readiness Unit", role: "HEAT / MRE", image: "/assets/images/neuron-cons/HEAT-trainings.jpeg" }
];

export const teamProfiles = [
  { name: "Operations Director", role: "Strategic Security Oversight", image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?auto=format&fit=crop&w=700&h=900&q=80" },
  { name: "Protection Team Lead", role: "Executive Protection Planning", image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&w=700&h=900&q=80" },
  { name: "Mobility Coordinator", role: "Secure Movement Coordination", image: "https://images.unsplash.com/photo-1474631245212-32dc3c8310c6?auto=format&fit=crop&w=700&h=900&q=80" },
  { name: "Surveillance Supervisor", role: "Field Monitoring & Reporting", image: "https://images.unsplash.com/photo-1542909168-82c3e7fdca5c?auto=format&fit=crop&w=700&h=900&q=80" },
  { name: "Training Lead", role: "HEAT / MRE Delivery", image: "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=700&h=900&q=80" },
  { name: "Liaison Coordinator", role: "Stakeholder Engagement", image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&w=700&h=900&q=80" },
  { name: "Control Room Analyst", role: "Situation Tracking", image: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?auto=format&fit=crop&w=700&h=900&q=80" },
  { name: "Response Supervisor", role: "Incident Escalation", image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?auto=format&fit=crop&w=700&h=900&q=80" }
];

export const testimonials = [
  {
    position: "Security Director",
    name: "Regional Logistics Group",
    text: "Neuron helped us secure executive travel and field deployment with strong coordination and consistent reporting."
  },
  {
    position: "Operations Manager",
    name: "Energy Project Consortium",
    text: "Their site security structure and escalation process gave our teams confidence during high-pressure project windows."
  },
  {
    position: "Programme Lead",
    name: "Humanitarian Response Network",
    text: "The training and movement support were practical, well-paced and directly useful for our field teams."
  },
  {
    position: "Principal Office",
    name: "Private Client Service",
    text: "Discreet coverage, dependable timing and professional conduct across every leg of our movement plan."
  },
  {
    position: "Risk & Compliance Lead",
    name: "Infrastructure Partner",
    text: "Their advisory and on-ground implementation model gave us a clear bridge between policy and execution."
  },
  {
    position: "Country Program Coordinator",
    name: "Development Program",
    text: "Community-aware execution and clear communication helped us reduce disruptions in sensitive operating zones."
  }
];

export const blogPosts = [
  {
    slug: "pre-travel-security-briefs-executive-exposure",
    title: "How Pre-Travel Security Briefs Reduce Executive Exposure",
    summary: "A practical framework for route risk review, timing controls and movement communication before travel starts.",
    date: "18 Apr 2026",
    comments: 3,
    image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?auto=format&fit=crop&w=900&h=700&q=80"
  },
  {
    slug: "protective-surveillance-workflow",
    title: "Building a Reliable Protective Surveillance Workflow",
    summary: "Key lessons on structuring surveillance teams, reporting cadence and escalation thresholds.",
    date: "12 Apr 2026",
    comments: 5,
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&w=900&h=700&q=80"
  },
  {
    slug: "heat-training-field-decisions",
    title: "HEAT Training That Improves Real Field Decisions",
    summary: "Why scenario-based training improves response quality compared to lecture-only formats.",
    date: "06 Apr 2026",
    comments: 2,
    image: "/assets/images/neuron-cons/HEAT-trainings.jpeg"
  },
  {
    slug: "stakeholder-liaison-security-multiplier",
    title: "Stakeholder Liaison as a Security Multiplier",
    summary: "How structured local engagement can improve operational stability and trust around project sites.",
    date: "30 Mar 2026",
    comments: 4,
    image: "https://images.unsplash.com/photo-1521791136064-7986c2920216?auto=format&fit=crop&w=900&h=700&q=80"
  },
  {
    slug: "balancing-static-security-mobile-coverage",
    title: "Balancing Static Security and Mobile Coverage",
    summary: "Approaches for protecting fixed assets while keeping teams safe on active movement plans.",
    date: "22 Mar 2026",
    comments: 1,
    image: "https://images.unsplash.com/photo-1473445361085-b9a07f55608b?auto=format&fit=crop&w=900&h=700&q=80"
  },
  {
    slug: "designing-discreet-protection-low-friction",
    title: "Designing Discreet Protection With Low Operational Friction",
    summary: "Delivering protective coverage that safeguards principals while preserving productivity.",
    date: "15 Mar 2026",
    comments: 6,
    image: "https://images.unsplash.com/photo-1492724441997-5dc865305da7?auto=format&fit=crop&w=900&h=700&q=80"
  }
];

export const faqGeneral = [
  {
    question: "What services does Neuron Consultancy Kenya Ltd provide?",
    answer:
      "We provide executive and VIP protection, protective surveillance, secure mobility, project and asset security, risk advisory, and HEAT/MRE readiness training."
  },
  {
    question: "Which sectors do you support?",
    answer:
      "Our clients include corporate organizations, infrastructure projects, private principals, development partners and field-based programs requiring controlled security delivery."
  },
  {
    question: "Do you support operations outside Nairobi?",
    answer:
      "Yes. We support assignments across Kenya and the region, subject to scope, threat profile, logistics and legal compliance requirements."
  },
  {
    question: "How do you tailor your service model?",
    answer:
      "Every assignment begins with a risk and exposure review, then we define manpower, procedures, escalation channels and reporting standards around your exact operating environment."
  },
  {
    question: "Can you handle short-term and long-term assignments?",
    answer:
      "Yes. We support single-event protection, travel windows, and long-duration project deployments with ongoing supervision and periodic review."
  }
];

export const faqSupport = [
  {
    question: "How quickly can operations be mobilized?",
    answer:
      "Mobilization timelines depend on assignment complexity and location. Priority deployments can be activated quickly once scope, approvals and logistics are confirmed."
  },
  {
    question: "Do you provide 24/7 command and escalation support?",
    answer:
      "Yes. Our model includes continuous contact channels and escalation pathways for time-sensitive incidents and rapid decision support."
  },
  {
    question: "What reporting can clients expect?",
    answer:
      "Clients receive structured updates, incident logs and operational summaries designed to support leadership decisions and compliance needs."
  },
  {
    question: "Can Neuron work with internal client teams?",
    answer:
      "Absolutely. We integrate with client leadership, HSE, project management and admin teams to keep security measures practical and aligned."
  },
  {
    question: "How do we request an engagement?",
    answer:
      "Use the contact page or call directly. We schedule an initial briefing, review risks and provide a tailored engagement proposal."
  }
];
